<template>
  <div class="cookie-consent-bar elevation-12" v-if="visible">
    <v-toolbar dense dark :color="secondaryColor">
      <v-toolbar-title v-html="message" />
      <v-spacer />
      <v-btn raised v-html="view" @click="viewPolicy" :color="primaryColor" />
      <v-btn raised v-html="dismiss" @click="dismissMessage" :color="primaryColor" />
    </v-toolbar>
  </div>
</template>
<script>
export default {
  name: 'CookieConsentBar',
  data () {
    return {
      message: this.$attrs.message || 'We use cookies to ensure you get the best experience.',
      dismiss: this.$attrs.ok || 'OK',
      view: this.$attrs.view || 'Policy',
      visible: false,
      page: this.$attrs.page || '/cookies',
      cookie: this.$attrs.cookie || '_cookie_policy_',
      days: this.$attrs.days || 7,
      primaryColor: this.$store.state.primaryColor,
      secondaryColor: this.$store.state.secondaryColor
    }
  },
  mounted () {
    if (!this.getCookie(this.cookie)) {
      this.visible = true
    }
  },
  methods: {
    /**
     * Get cookie
     * @method setCookie
     * @param {String} name
     * @private
     * @return {String}
     * **/
    getCookie (name) {
      const dc = document.cookie
      const prefix = name + '='
      let begin = dc.indexOf('; ' + prefix)

      if (begin === -1) {
        begin = dc.indexOf(prefix)
        if (begin !== 0) {
          return null
        }
      } else {
        begin += 2
        var end = document.cookie.indexOf(';', begin)

        if (end === -1) {
          end = dc.length
        }
      }
      return unescape(dc.substring(begin + prefix.length, end))
    },
    /**
     * Set cookie
     * @method setCookie
     * @param {String} name
     * @param {String} value
     * @param {Number} days
     * @private
     * @return void
     * **/
    setCookie (name, value, days) {
      const d = new Date()
      let expires

      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = `expires=${d.toUTCString()}`
      document.cookie = `${name}=${value};${expires}`
    },
    /**
     * Navigate to the cookie policy page
     * @method viewPolicy
     * @return void
     */
    viewPolicy () {
      this.$router.push({
        name: 'Cookies',
        params: {
          slug: this.page
        }
      })
    },
    /**
     * Close the message
     * @method dismissMessage
     * @return void
     */
    dismissMessage () {
      this.visible = false
      this.setCookie(this.cookie, true, this.days)
    }
  }
}
</script>
<style>
.cookie-consent-bar
{
  position: fixed;
  z-index: 1000;
  bottom: 0;
  width: 100%;
  opacity: .85;
  transition: opacity .25s ease-in-out;
}

.cookie-consent-bar:hover
{
  opacity: 1;
}

.cookie-consent-bar .toolbar__title
{
  font-size: 1em;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/cookie-consent-bar.vue